import "./index.css";
import "react-toastify/dist/ReactToastify.css";

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import React from "react";
import ReactDOM from "react-dom";
import { ToastContainer } from "react-toastify";

import App from "./App";

const isDevelopment = import.meta.env.VITE_APP_DEV_MODE;

if (!isDevelopment)
  Sentry.init({
    dsn: process.env.SENTRY_DNS,
    integrations: [new BrowserTracing()],

    tracesSampleRate: 1.0,
  });

ReactDOM.render(
  <React.StrictMode>
    <App />
    <ToastContainer />
  </React.StrictMode>,
  document.getElementById("root")
);
